export default __webpack_public_path__ + "static/media/service-4_large.01570910.png";